var map = {
	"./blog.png": "7daf",
	"./ebulletin.png": "19e2",
	"./event.png": "5a92",
	"./icon-back.png": "5913",
	"./image-placeholder-square.svg": "166c",
	"./image-placeholder.svg": "c208",
	"./news.png": "75a7",
	"./paginate.svg": "8c6c",
	"./podcast-series.jpg": "ee06",
	"./podcast-singular.jpg": "d82f",
	"./poster-placeholder.png": "faab",
	"./programme-area.png": "90ed",
	"./project.png": "89f2",
	"./publication.png": "cc7a",
	"./sign-up.png": "c857",
	"./unrisd-logo-desktop.png": "3913",
	"./unrisd-logo-mobile.png": "96dd",
	"./unrisd60-desktop.png": "8cef",
	"./unrisd60-mobile.png": "7a76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "efc5";